type LocalDateTimeParts = {
  year: number;
  month: number;
  day: number;
  hours: number;
  minutes: number;
  seconds: number;
};
const parse = (value: string): LocalDateTimeParts | null => {
  const m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?$/.exec(value);
  if (!m) return null;
  const [year, month, day, hours, minutes, seconds] = m.slice(1).map((part) => Number(part ?? '0'));
  const d = new Date(year, month - 1, day, hours, minutes, seconds);
  return d.getFullYear() === year && d.getMonth() === month - 1 && d.getDate() === day
    ? { year, month, day, hours, minutes, seconds }
    : null;
};
const time = (p: LocalDateTimeParts) =>
  Date.UTC(p.year, p.month - 1, p.day, p.hours, p.minutes, p.seconds);
export const formatLocalDateTime = (value: string) => {
  const p = parse(value);
  if (!p) return value;
  const pad = (part: number) => String(part).padStart(2, '0');
  return `${p.year}-${pad(p.month)}-${pad(p.day)}T${pad(p.hours)}:${pad(p.minutes)}:${pad(p.seconds)}`;
};
export const getLocalDurationHours = (startValue: string, endValue: string): number | null => {
  const start = parse(startValue);
  const end = parse(endValue);
  if (!start || !end) return null;
  const result = (time(end) - time(start)) / 3_600_000;
  return result > 0 ? Math.round(result * 100) / 100 : null;
};
export const validateAutomaticWorkLogInput = (
  taskName: string,
  employeeIds: number[],
  logStart: string,
  logEnd: string
): string | null => {
  if (!taskName.trim()) return 'Task name is required.';
  if (!employeeIds.length) return 'Select at least one employee.';
  const start = parse(logStart);
  const end = parse(logEnd);
  if (!start) return 'Work Log Start is required.';
  if (!end) return 'Work Log End is required.';
  if (start.year !== end.year || start.month !== end.month || start.day !== end.day)
    return 'Work Log Start and End must be on the same day.';
  return time(end) <= time(start) ? 'Work Log End must be later than Work Log Start.' : null;
};
